import { connect, MapDispatchToPropsFunction } from 'react-redux'
import { State } from 'interfaces/state'
import {
  hidePeergroupPopupActionCreator,
  registerPeergroupPopupTimeoutActionCreator,
  setShownSidebarPaneActionCreator,
  showPeergroupPopupActionCreator,
} from 'actions/sidebarActions'
import { selectRelationActionCreator } from 'actions/peergroupActions'
import {
  anyPopupShownSelector,
  isPeergroupSelectedSelector,
  isPopupShownSelector,
  peergroupPopupTimeoutIdSelector,
  createRelationSelector,
} from 'selectors/peergroupSelectors'
import { captureForgottenGuard } from 'helpers/errorHelpers'
import {
  PeergroupMenuItem,
  PeergroupMenuItemStateProps,
  PeergroupMenuItemDispatchProps,
  PeergroupMenuItemOwnProps,
} from 'components/features/pfm/PeergroupMenuItem/PeergroupMenuItem'
import { isMobileOrTabletSelector, viewportSegmentSelector } from 'selectors/viewportSelectors'
import { SLUGS } from 'constants/peergroups'
import { createSelector } from 'reselect'
import { openSubscriptionPageActionCreator } from 'actions/floatingPanesActions'


const createKindDependentPropsSelector = () => {
  const relationSelector = createRelationSelector()

  return (state: State, ownProps: PeergroupMenuItemOwnProps): Pick<PeergroupMenuItemStateProps, 'kind' | 'name'> => {
    if (ownProps.relationId === 'member') {
      return {
        name: 'You',
        kind: 'member',
      }
    }

    const relation = relationSelector(state, ownProps)
    if (!relation) {
      captureForgottenGuard('PeergroupContainer', 'peergroupsGuard')
      // only for TS, this never should happen because of the guards
      return {
        kind: 'others',
        name: '',
      }
    }

    return {
      kind: relation.is_preset && relation.slug === SLUGS.peers ? 'peers' : 'others',
      name: relation.name,
    }
  }
}

const mapStateToProps = createSelector(
  isPeergroupSelectedSelector,
  isPopupShownSelector,
  anyPopupShownSelector,
  peergroupPopupTimeoutIdSelector,
  createKindDependentPropsSelector(),
  viewportSegmentSelector,
  isMobileOrTabletSelector,
  (isSelected, isPopupShown, anyPopupShown, timeoutId, kindDependentProps, viewportSegment, isTabletOrBelow): PeergroupMenuItemStateProps => ({
    isSelected,
    isTabletOrBelow,
    isPopupShown,
    anyPopupShown,
    timeoutId,
    viewportSegment,
    ...kindDependentProps,
  })
)


const mapDispatchToProps: MapDispatchToPropsFunction<PeergroupMenuItemDispatchProps, PeergroupMenuItemOwnProps> = (dispatch, { relationId }) => {
  const dispatches = {
    showPopup: (boundingRect: ClientRect) => dispatch(showPeergroupPopupActionCreator(relationId, boundingRect)),
    hidePopup: () => dispatch(hidePeergroupPopupActionCreator(relationId)),
    hideSidebar: () => dispatch(setShownSidebarPaneActionCreator(null)),

    registerTimeout: (timeoutId: number) => dispatch(registerPeergroupPopupTimeoutActionCreator(timeoutId)),
    openSubscriptionPane: () => dispatch(openSubscriptionPageActionCreator()),
  }

  const relationDispatches = relationId !== 'member' ? {
    selectRelation: () => dispatch(selectRelationActionCreator(relationId)),
  } : {
    selectRelation: () => { /* do nothing */ },
  }

  return ({
    ...dispatches,
    ...relationDispatches,
  })
}

const PeergroupMenuItemContainer = connect<PeergroupMenuItemStateProps, PeergroupMenuItemDispatchProps, PeergroupMenuItemOwnProps>(
  mapStateToProps, mapDispatchToProps
)(PeergroupMenuItem)
export default PeergroupMenuItemContainer
